function openAuthModal(data: any) {
  return {
    type: 'OPEN_AUTH_MODAL',
    payload: data,
  };
}

function closeAuthModal() {
  return {
    type: 'CLOSE_AUTH_MODAL',
    payload: {},
  };
}

function openTeamInviteModal() {
  return {
    type: 'OPEN_TEAM_INVITE_MODAL',
    payload: {},
  };
}

function closeTeamInviteModal() {
  return {
    type: 'CLOSE_TEAM_INVITE_MODAL',
    payload: {},
  };
}

function openTeamSelectionModal() {
  return {
    type: 'OPEN_TEAM_SELECTION_MODAL',
    payload: {},
  };
}

function closeTeamSelectionModal() {
  return {
    type: 'CLOSE_TEAM_SELECTION_MODAL',
    payload: {},
  };
}

function openTeamJoinedModal() {
  return {
    type: 'OPEN_TEAM_JOINED_MODAL',
    payload: {},
  };
}

function closeTeamJoinedModal() {
  return {
    type: 'CLOSE_TEAM_JOINED_MODAL',
    payload: {},
  };
}

function openTypeformPersonalModal() {
  return {
    type: 'OPEN_TYPEFORM_PERSONA_MODAL',
    payload: {},
  };
}

function closeTypeformPersonalModal() {
  return {
    type: 'CLOSE_TYPEFORM_PERSONA_MODAL',
    payload: {},
  };
}

function openErrorToast(data: any) {
  return {
    type: 'OPEN_ERROR_TOAST',
    payload: data,
  };
}

function closeErrorToast() {
  return {
    type: 'CLOSE_ERROR_TOAST',
    payload: {},
  };
}

function setRedirectionLink(data: any) {
  return {
    type: 'SET_REDIRECTION_LINK',
    payload: data,
  };
}

function setSocialLinks(data: any) {
  return {
    type: 'SET_SOCIAL_LINKS',
    payload: data,
  };
}

function setEditorParams(data: any) {
  return {
    type: 'SET_EDITOR_PARAMS',
    payload: data,
  };
}

export {
  openAuthModal,
  closeAuthModal,
  openTeamInviteModal,
  closeTeamInviteModal,
  openTeamSelectionModal,
  closeTeamSelectionModal,
  openTeamJoinedModal,
  closeTeamJoinedModal,
  openErrorToast,
  closeErrorToast,
  setRedirectionLink,
  setSocialLinks,
  closeTypeformPersonalModal,
  openTypeformPersonalModal,
  setEditorParams,
};
